import { render, staticRenderFns } from "./social_media_posts.vue?vue&type=template&id=3082b53d&"
import script from "./social_media_posts.vue?vue&type=script&lang=js&"
export * from "./social_media_posts.vue?vue&type=script&lang=js&"
import style0 from "./social_media_posts.vue?vue&type=style&index=0&id=3082b53d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports